import React from 'react'
import ProjectCard from '../Components/ProjectCard'
import { Box, Toolbar } from '@mui/material'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    height: { xs: "10vh", md: "15vh", xl: "2" }
}));

const projectData = [["/images/projectImages/IrishResearchCouncil.png", "Project: Towards Energy Optimized High-Performance Computing: Reducing Energy Cost of Communication on HPC Platforms.", "Source: Irish Research Council (IRC)<br/>Duration: Sept. 2023 - Sept. 2027"],
["/images/projectImages/TUDublin.png", "Project: Scalable Performance Optimization of Machine Learning based Big data Analytics Applications on Modern Heterogeneous and Hybrid Computing Platforms.", "Source: TU Dublin Award<br/>Duration: Dec. 2023- Dec. 2027"],
["/images/projectImages/ScienceFoundationIrelandv2 - Copy.png", "Project: A framework for efficient and scalable High Performance Big Data Risk Analytics (HP-Analytics)", "Source: Science Foundation Ireland (SFI) + Fidelity Ireland (19/IFA/7400)<br/>Duration:1 Jun 2020 - 31 Aug 2021"],
["/images/projectImages/IrishResearchCouncilIBM (2).png", "Project: Extreme Scale Systems Data Analytics", "Source: IRCSET EPS + IBM<br/>Duration: May 2012-May 2016"]]

export default function Projects() {

    return (
        <Box sx={{ flexGrow: 1, padding: 2 }}>
            <Toolbar />
            <Grid container spacing={2}>
                {
                    projectData.map((value, index) =>
                        <Grid item xs={12} md={6}>
                            <Item key={index} >
                                <ProjectCard
                                    img={value[0]} title={value[1]} details={value[2]} />
                            </Item>
                        </Grid>
                    )
                }



            </Grid>
        </Box >
    )
}
